import {createSignal} from '@pexip/signal';
import type {MediaSessionController} from '@pexip/media';

/**
 * Emits the media session presenting the ongoing meeting to the platform's
 * media controls, or `undefined` once the meeting is over.
 */
export const mediaSessionSignal = createSignal<
    MediaSessionController | undefined
>({
    name: 'media-session:session',
});
